// extracted by css-extract-rspack-plugin
export default {"root":"tBqx7U","collapsed":"tYt6Zd"};